__turbopack_context__.v({
  "dialogContainer": "SignatureRequestDialog-module__Me4k0W__dialogContainer",
  "iframe": "SignatureRequestDialog-module__Me4k0W__iframe",
});
